import { esDO } from './es-DO';

/**
 * es-MX overrides — solo strings que difieren de es-DO.
 * Resto fall-through al base es-DO.
 */
const overrides: Partial<typeof esDO> = {
  // Regionalismos
  'properties.type.apartment': 'Departamento',
  'leads.stage.closed_won': 'Cerrado ganado',
  'billing.upgrade': 'Actualizar plan',
};

export const esMX = { ...esDO, ...overrides };
